/* eslint-disable react/style-prop-object */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
import type { FinancialSegmentsFields } from "components/stocks/modern/OperatingSegments/types";
import getYear from "date-fns/getYear";
import parseISO from "date-fns/parseISO";
import flatten from "lodash/flatten";
import uniq from "lodash/uniq";

export default function calculateFilterOptions(
  financialSegments: FinancialSegmentsFields,
  indicatorsOrder: string[] = [],
) {
  return financialSegments.segments.reduce(
    (state, segment) => {
      const yearsByIndicator = segment.financialIndicators.map((indicator) => ({
        name: indicator.name,
        years: indicator.history
          .filter((item) => item.value > 0)
          .map((item) => getYear(parseISO(item.periodEndingDate))),
      }));
      const byIndicator = yearsByIndicator.reduce(
        (state, item) => ({
          ...state,
          [item.name]: uniq([...(state[item.name] || []), ...item.years]),
        }),
        state.byIndicator,
      );

      const allYears = uniq(flatten([...state.allYears, ...yearsByIndicator.map((item) => item.years)])).sort(
        (a, b) => b - a,
      );

      return {
        allYears,
        byIndicator,
        indicatorsByYear: Object.entries(byIndicator).reduce((state, [indicator, years]) => {
          const newState = state;
          years.forEach((year) => {
            newState[year] = uniq([...(newState[year] || []), indicator]).sort((a, b) => {
              return indicatorsOrder.indexOf(a) - indicatorsOrder.indexOf(b);
            });
          });
          return newState;
        }, {} as Record<number, string[]>),
      };
    },
    {
      allYears: [] as number[],
      byIndicator: {} as Record<string, number[]>,
      indicatorsByYear: {} as Record<number, string[]>,
    },
  );
}
